<span class="agent-request-button-wrapper">
  <button
    pButton
    type="button"
    variant="outlined"
    size="small"
    class="agent-request-button"
    data-cy="request-from-agent"
    (click)="requested.emit()"
  >
    <i class="pi pi-envelope"></i>
    <span>{{ label() }}</span>
  </button>
  <app-feature-badge kind="new" />
</span>
@if (count() > 0) {
  <a
    class="agent-request-link"
    data-cy="agent-requests-sent"
    routerLink="/quote/requests"
    [queryParams]="queryParams()"
  >
    {{ countLabel() }}
    <i class="pi pi-angle-right"></i>
  </a>
}
